import { render, staticRenderFns } from "./DetailsRuleItem.vue?vue&type=template&id=68b03b0e&scoped=true"
import script from "./DetailsRuleItem.vue?vue&type=script&lang=js"
export * from "./DetailsRuleItem.vue?vue&type=script&lang=js"
import style0 from "./DetailsRuleItem.vue?vue&type=style&index=0&id=68b03b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b03b0e",
  null
  
)

export default component.exports